import { GrupoFormKeys } from 'src/modules/motor-credito/grupo/form'
import { Places } from 'src/Constants'

export class AnaliseSelectKeys extends GrupoFormKeys {
    get place() {
        return Places.mcAnaliseSelect
    }
}

export default AnaliseSelectKeys
